import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, useWindowDimensions, ViewStyle} from 'react-native';

export default (props: ITheme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: props.colors.white,
    },
    bottomOffset: {
      height: 18,
    },
    composerContainer: {
      alignItems: 'center',
    },
  });
